import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { render } from 'react-dom';
import { App } from './App';
// Optimize rendering
render(<React.StrictMode data-id="element-155">
    <ChakraProvider data-id="element-156">
      <App data-id="element-157" />
    </ChakraProvider>
  </React.StrictMode>, document.getElementById('root'));
// Add performance observer for monitoring
if (typeof window !== 'undefined' && 'PerformanceObserver' in window) {
  try {
    const observer = new PerformanceObserver(list => {
      for (const entry of list.getEntries()) {
        // Log LCP for debugging
        if (entry.entryType === 'largest-contentful-paint') {
          console.log('LCP:', entry.startTime);
        }
      }
    });
    observer.observe({
      entryTypes: ['largest-contentful-paint']
    });
  } catch (e) {
    // Ignore errors
  }
}